import React, { useState } from "react";
import axios from "axios";
import "./ContactPageForm.css";

const ContactPageForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    type: "",
    message: "",
    date: new Date().toISOString().split("T")[0], // Current date
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://api.dremerz.net/api/Project_17_ManPowerWebsite_feedback_Aplication_Form",
        formData
      );
      alert("Message sent successfully!");
      setFormData({
        name: "",
        mobile: "",
        email: "",
        type: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message:", error);
      alert("Failed to send message. Please try again.");
    }
  };
  return (
    <div className="container ContactPageForm-container py-5">
      <div className="row align-items-center">
        {/* Left Side - Contact Information */}
        <div className="col-md-6 mb-4">
          <button className="ContactPageForm-contactBtn">
            Contact Us <span className="arrow">→</span>
          </button>
          <h2 className="ContactPageForm-title">
            Don't Hesitate To Ask <br /> Any Questions
          </h2>
          <p className="ContactPageForm-description">
            Get Employees For your jobs to millions of monthly users From Us
          </p>

          <div className="row">
            <div className="col-12">
              <div className="ContactPageForm-infoBox">
                <i className="fa fa-phone"></i>
                <h5>Monday to Saturday - 9:00 AM to 6:00 PM</h5>
                <p>
                  <a
                    href="tel:+919840562357"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    +91 98400 88046 | 044 - 4614 6838
                  </a>
                </p>
                <p>(closed on public holidays)</p>
              </div>
            </div>
            <div className="col-12">
              <div className="ContactPageForm-infoBox">
                <i className="fa fa-envelope"></i>
                <h5>Email Us</h5>
                <p>info@srimathiconsultancy.com</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Feedback Form */}
        <div className="col-md-6 mt-5">
          <div className="ContactPageForm-formBox">
            <h3 className="ContactPageForm-formTitle">Get in Touch</h3>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name*"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Mobile Number*"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Email Address*"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <select
                    className="form-control"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Choose types of ...</option>
                    <option value="Type 1">Positive Feedback</option>
                    <option value="Type 2">Constructive Feedback</option>
                  </select>
                </div>
                <div className="col-12 mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Additional Message"
                    rows="3"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <div className="col-12">
                  <button className="ContactPageForm-submitBtn" type="submit">
                    SEND MESSAGE <i className="fa fa-paper-plane"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPageForm;
